import { CallbackProperty, Cartesian3 } from "cesium";
import { PolylineProps } from "./polyline-edit-options";

/* NOTE: Extracted from angular-cesium with updated types  */

/* eslint-disable no-underscore-dangle */
export class EditPolyline {
    private static counter = 0;
    private editedEntityId: string;
    private id: string;
    private positions: Cartesian3[];
    private _polylineProps: PolylineProps;

    constructor(entityId: string, startPosition: Cartesian3, endPosition: Cartesian3, polylineProps?: PolylineProps) {
        this.editedEntityId = entityId;
        this.id = this.generateId();
        this.positions = [startPosition, endPosition];
        this._polylineProps = { ...polylineProps };
    }

    public get props(): PolylineProps {
        return this._polylineProps;
    }

    public set props(value: PolylineProps) {
        this._polylineProps = value;
    }

    public getEditedEntityId(): string {
        return this.editedEntityId;
    }

    public getPositions(): any[] {
        return this.positions.map((p) => p.clone());
    }

    public getPositionsCallbackProperty() {
        return new CallbackProperty(this.getPositions.bind(this), false);
    }

    public validatePositions(): boolean {
        return this.positions[0] !== undefined && this.positions[1] !== undefined;
    }

    public getStartPosition() {
        return this.positions[0];
    }

    public getEndPosition() {
        return this.positions[1];
    }

    public setStartPosition(position: Cartesian3) {
        this.positions[0] = position;
    }

    public setEndPosition(position: Cartesian3) {
        this.positions[1] = position;
    }

    public getId(): string {
        return this.id;
    }

    private generateId(): string {
        return "edit-polyline-" + EditPolyline.counter++;
    }
}
